import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ContextApi } from "../../../store/ContextApi";
import PageTitle from "../../layouts/PageTitle";
import SpinnerLoading from "../../components/spinner-loading/SpinnerLoading";
import FaildLoadData from "../../global-components/FaildLoadData/FaildLoadData";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import LoadingScreen from "../../components/loading-screen/LoadingScreen";
import { toast } from "react-toastify";
import checkPermissions from "../../global-functions/checkPermissionsFunc";
import { getLanguagesFunc } from "../../../store/custom-actions/language/GetLanguagesSlicer";
import { deleteLanguageFunc } from "../../../store/custom-actions/language/DeleteLanguageSlicer";
import { makeLangDefaultFunc } from "../../../store/custom-actions/language/MakeLangDefaultSlicer";
import LanguageDescion from "./languageDescion";
import NewLangForm from "../../custom-forms/settings-pages/languages/NewLang";
import { useTranslation } from "react-i18next";

export default function LanguagesPage() {
  const { t } = useTranslation();
  const { loading: getLanguagesLoading, data: languagesData } = useSelector(
    (state) => state.getLanguageSlicer
  );
  const { loading: deleteLanguageLoading } = useSelector(
    (state) => state.deleteLanguageSlicer
  );
  const { loading: makeLangDefaultLoading } = useSelector(
    (state) => state.makeLangDefaultSlicer
  );
  const contextApi = useContext(ContextApi);
  const languages_API_URL = `${process.env.REACT_APP_VERSEL_API}/api/dashboard/languages`;
  const [languagesList, setLanguagesList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [showNewLangForm, setShowNewLangForm] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    const getLanguages = async () => {
      try {
        dispatch(getLanguagesFunc(languages_API_URL));
      } catch (error) {
        console.log(error);
      }
    };
    getLanguages();
  }, []);
  useEffect(() => {
    languagesData && setLanguagesList(languagesData);
    languagesData &&
      (jobData.current = languagesData.slice(
        activePag.current * sort,
        (activePag.current + 1) * sort
      ));
  }, [languagesData]);
  const sort = 20;
  let paggination = Array(Math.ceil(languagesList.length / sort))
    .fill()
    .map((_, i) => i + 1);

  const activePag = useRef(0);
  const jobData = useRef(
    languagesList.slice(
      activePag.current * sort,
      (activePag.current + 1) * sort
    )
  );
  const onClick = (i) => {
    activePag.current = i;
    jobData.current = languagesList.slice(
      activePag.current * sort,
      (activePag.current + 1) * sort
    );
  };
  const search = () => {
    if (searchValue !== "") {
      const searchResult =
        languagesData &&
        languagesData.length >= 1 &&
        languagesData.filter((lang) =>
          lang.name
            .toLocaleLowerCase()
            .includes(searchValue.toLocaleLowerCase())
        );
      jobData.current = searchResult;
    } else {
      dispatch(getLanguagesFunc(languages_API_URL));
    }
  };
  useEffect(() => {
    searchValue === "" && dispatch(getLanguagesFunc(languages_API_URL));
  }, [searchValue]);
  const deleteLang = async (id) => {
    swal({
      title: t("Confirm Language Deletion"),
      text: t(`Once deleted, This Language will not be avilable`),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        dispatch(deleteLanguageFunc(`${languages_API_URL}/${id}`)).then(
          (result) => {
            if (result.payload.success === true) {
              dispatch(getLanguagesFunc(languages_API_URL));
              toast.success(`${result.payload.message} !`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
            }
          }
        );
      }
    });
  };

  const makeLangDefault = async (id) => {
    swal({
      title: t("Confirm Make This Language Default"),
      text: t(`Once Make it, This Language Will be In all of App!`),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const form = new FormData();
        form.append("_method", "PUT");
        dispatch(
          makeLangDefaultFunc({
            api: `${languages_API_URL}/${id}/make-default`,
            data: form,
          })
        ).then((result) => {
          if (result.payload.success === true) {
            dispatch(getLanguagesFunc(languages_API_URL));
            toast.success(`${result.payload.message} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
        });
      }
    });
  };

  return (
    <>
      <PageTitle motherMenu={"Dashboard"} activeMenu={"Languages"} />
      {getLanguagesLoading ? (
        <SpinnerLoading />
      ) : languagesData ? (
        <div className="col-12">
          <div className="card">
            {/* Card Header */}
            <div className="card-header d-flex justify-content-between align-items-center">
              <h4 className="card-title mb-0">{t("Languages")}</h4>
              <div className="d-flex align-items-center">
                {/* Search */}
                <div className="input-group me-2">
                  <span
                    className="input-group-text"
                    style={{ cursor: "pointer" }}
                    onClick={() => search()}
                  >
                    <Link to={"#"}>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M27.414 24.586L22.337 19.509C23.386 17.928 24 16.035 24 14C24 8.486 19.514 4 14 4C8.486 4 4 8.486 4 14C4 19.514 8.486 24 14 24C16.035 24 17.928 23.386 19.509 22.337L24.586 27.414C25.366 28.195 26.634 28.195 27.414 27.414C28.195 26.633 28.195 25.367 27.414 24.586ZM7 14C7 10.14 10.14 7 14 7C17.86 7 21 10.14 21 14C21 17.86 17.86 21 14 21C10.14 21 7 17.86 7 14Z"
                          fill="var(--primary)"
                        ></path>
                      </svg>
                    </Link>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("Search here...")}
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                    }}
                  />
                </div>

                {/* Create Button */}
                {checkPermissions(
                  "create language",
                  <Link
                    to={"#"}
                    className="btn btn-primary btn-sm"
                    onClick={() => setShowNewLangForm(true)}
                  >
                    {t("Create")}
                  </Link>
                )}
              </div>
            </div>

            {/* Card Body */}
            <div className="card-body">
              <div className="table-responsive">
                <table className="display w-100 dataTable">
                  <thead className="table-light">
                    <tr>
                      <th>#{t("ID")}</th>
                      <th>{t("Lang")}</th>
                      <th>{t("Direction")}</th>
                      <th>{t("Slug")}</th>
                      <th>{t("Default")}</th>
                      {checkPermissions(
                        ["update coupons", "delete coupons"],
                        <th>{t("Actions")}</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {languagesList && languagesList.length >= 1 ? (
                      jobData.current.map((lang, index) => (
                        <tr key={index}>
                          <td>{lang.id}</td>
                          <td>{lang.name}</td>
                          <td>{lang.direction?.toUpperCase()}</td>
                          <td>{lang.slug}</td>
                          <td>{lang.default ? t("Yes") : t("No")}</td>
                          {checkPermissions(
                            ["update language", "delete language"],
                            <td>
                              <LanguageDescion
                                langId={lang.id}
                                deleteFunction={() => deleteLang(lang.id)}
                                makeDefaultFunction={() =>
                                  makeLangDefault(lang.id)
                                }
                                defaultStatus={lang.default}
                              />
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center">
                          {t("No data available")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* Pagination */}
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mt-3">
                  <div className="mb-2 mb-sm-0">
                    {t("Showing")} {activePag.current * sort + 1} to{" "}
                    {languagesList.length > (activePag.current + 1) * sort
                      ? (activePag.current + 1) * sort
                      : languagesList.length}{" "}
                    {t("Of")} {languagesList.length} {t("Entries")}
                  </div>
                  <nav>
                    <ul className="pagination mb-0">
                      <li
                        className={`page-item ${
                          activePag.current === 0 ? "disabled" : ""
                        }`}
                      >
                        <Link
                          className="page-link"
                          to="#"
                          onClick={() =>
                            activePag.current > 0 &&
                            onClick(activePag.current - 1)
                          }
                        >
                          «
                        </Link>
                      </li>
                      {paggination.map((number, i) => (
                        <li
                          key={i}
                          className={`page-item ${
                            activePag.current === i ? "active" : ""
                          }`}
                        >
                          <Link
                            className="page-link"
                            to="#"
                            onClick={() => onClick(i)}
                          >
                            {number}
                          </Link>
                        </li>
                      ))}
                      <li
                        className={`page-item ${
                          activePag.current + 1 >= paggination.length
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <Link
                          className="page-link"
                          to="#"
                          onClick={() =>
                            activePag.current + 1 < paggination.length &&
                            onClick(activePag.current + 1)
                          }
                        >
                          »
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <FaildLoadData
          refetchDataFunc={() => dispatch(getLanguagesFunc(languages_API_URL))}
        />
      )}
      <LoadingScreen loading={deleteLanguageLoading} />
      <LoadingScreen loading={makeLangDefaultLoading} />
      <NewLangForm
        show={showNewLangForm}
        hide={() => setShowNewLangForm(false)}
        languagesApi={languages_API_URL}
      />
    </>
  );
}
